import styled from 'styled-components';
import { layout, media, remCalc } from '@prisjakt/ui-base';

export const ErrorMessageWrapper = styled.div`
  display: flex;
  margin-left: auto;
  margin-right: auto;
  margin-top: ${layout.measurements.spacing400};
  max-width: ${layout.pageContent.maxWidth.rem};
  min-height: 400px;

  ${media.smallOnly`
    flex-direction: column;
    margin-top: ${layout.measurements.spacing200};
  `}
`;

export const ErrorMessageMedia = styled.div`
  padding: 0;

  > * {
    padding-right: ${remCalc(12)};
    padding-left: ${remCalc(12)};

    ${media.smallOnly`
      padding-left: 0;
      padding-right: 0;
    `}
  }

  ${media.smallOnly`
    margin-left: auto;
    margin-right: auto;
    margin-bottom: ${layout.measurements.spacing100};
  `}
`;

export const ErrorMessageContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-left: ${layout.measurements.spacing200};

  ${media.smallOnly`
    padding-left: 0;
    padding-right: 0;
    margin-left: 0;
  `}
`;

export const ErrorMessageButton = styled.div`
  margin-top: ${layout.measurements.spacing150};
  margin-bottom: ${layout.measurements.spacing150};

  ${media.smallOnly`
    display: flex;
    justify-content: center;
  `}
`;

export const ErrorMessageTitle = styled.h1`
  ${media.smallOnly`
    text-align: center;
  `}
`;

export const ErrorMessageSubtitle = styled.h2`
  ${media.smallOnly`
    text-align: center;
  `}
`;

export const ErrorMessageSupportLabel = styled.div`
  color: ${({ theme }) => theme.text.secondary};

  > a {
    color: ${({ theme }) => theme.text.secondary};
    text-decoration-line: underline;
  }

  ${media.smallOnly`
    text-align: center;
  `}
`;

export const ErrorMessageErrorLabel = styled.div`
  color: ${({ theme }) => theme.text.secondary};

  ${media.smallOnly`
    text-align: center;
  `}
`;

export const ErrorMessageHidden = styled.div`
  display: none;
`;
